import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  QueryList,
  SimpleChanges,
} from '@angular/core';
import { isNonNullish } from '@epicuro-next/utilities';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[atxTextFinder]',
  exportAs: 'atxTextFinder',
  standalone: false,
})
export class TextFinderDirective implements OnDestroy, OnChanges {
  /* eslint-disable @angular-eslint/no-input-rename */
  @Input('atxTextFinder')
  public refs?: QueryList<ElementRef>;

  @Input('atxTextFinderString')
  public searchString: string;

  @Input('atxTextFinderCallback')
  public callback: (ref: ElementRef, isFound: boolean) => void;

  @Input('atxTextFinderEnabled')
  public isEnabled = true;
  /* eslint-enable @angular-eslint/no-input-rename */

  public destroy$ = new Subject<void>();

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (!this.isEnabled) return;

    if (
      isNonNullish(changes.searchString) &&
      changes.searchString.currentValue !== changes.searchString.previousValue
    ) {
      if (this.refs?.length) {
        this.handleChanges(this.refs);
      } else {
        this.refs?.changes
          .pipe(take(1))
          .subscribe((queryList: QueryList<ElementRef>) => {
            this.handleChanges(queryList);
          });
      }
    }
  }

  public handleChanges(queryList?: QueryList<ElementRef>) {
    queryList?.forEach((ref) => {
      const isFound = this.searchString.length
        ? ref.nativeElement.textContent
            .toLowerCase()
            .includes(this.searchString.toLowerCase())
        : false;

      this.callback(ref, isFound);
    });
  }
}
